import { Spin } from "antd";
// import * as animationLoading from "constants/animation/loading.json";
// import Lottie from "react-lottie";

interface SuspenseLoadingProps {
  title?: string;
}

const SuspenseLoading = (props: SuspenseLoadingProps) => {
  const { title } = props;

  // const defaultOptions = {
  //   loop: true,
  //   autoplay: true,
  //   animationData: animationLoading,
  // };

  return (
    <div className="fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center z-[10000] bg-white">
      <Spin size="large" />
      <p className="text-dark mt-6 text-sm lg:text-md text-center">{title || "Xin vui lòng đợi trong giây lát!"}</p>
    </div>
  );
};

export default SuspenseLoading;
